import React from 'react';
import ColumnMapper, { OptionInfo, TargetField } from '#/common/components/ColumnMapper';
import { StyledNuvoBox } from '#/common/styles/template';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';

// Define the non-mandatory fields
const additionalFields = [
  { key: 'type', label: 'Type' },
  { key: 'cost', label: 'Planned Cost' },
  { key: 'planned_date', label: 'Planned Date' },
  { key: 'description', label: 'Description' },
] as TargetField[];

export interface MapCapitalNeedAdditionalFieldsStepProps {
  csvColumns: OptionInfo[];
  mapping: Record<string, string>;
  setMapping: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

const MapCapitalNeedAdditionalFieldsStep: React.FC<MapCapitalNeedAdditionalFieldsStepProps> = ({
  csvColumns,
  mapping,
  setMapping,
}) => {
  const { isDesktop } = useViewport();

  return (
    <StyledNuvoBox isDesktop={isDesktop}>
      <div className="box-caption">
        <NuvoLabel>Match Additional Columns</NuvoLabel>
      </div>

      <ColumnMapper
        sourceOptions={csvColumns}
        targetFields={additionalFields}
        mapping={mapping}
        setMapping={setMapping}
        sourceLabel="Your File Columns"
        targetLabel="TMM Columns"
      />
    </StyledNuvoBox>
  );
};

export default React.memo(MapCapitalNeedAdditionalFieldsStep);
